module.exports = __webpack_public_path__ + "static/media/jpg-icon.f5fb74d6.svg";